
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useUserProfile } from "./useUserProfile";
import { useSubscriptionStatus } from "./useSubscriptionStatus";
import { useDataRefresh } from "./useDataRefresh";
import { useAccountState } from "./useAccountState";

export const useUserAccount = () => {
  const navigate = useNavigate();
  
  // Get user profile data and related methods
  const { 
    userData, 
    loading: profileLoading, 
    fetchUserProfile, 
    updateProfileImage 
  } = useUserProfile();
  
  // Fetch subscription data based on user ID
  const { 
    subscriptionStatus, 
    loading: subscriptionLoading, 
    refreshSubscriptionStatus 
  } = useSubscriptionStatus(userData.userId);
  
  // Manage data refresh operations
  const {
    loading: refreshLoading,
    setLoading,
    refreshUserData
  } = useDataRefresh({
    fetchUserProfile,
    refreshSubscriptionStatus
  });
  
  // Manage overall loading state
  const { loading: accountStateLoading } = useAccountState({
    profileLoading,
    subscriptionLoading
  });
  
  // Initial data fetch
  useEffect(() => {
    refreshUserData();
  }, [refreshUserData]);

  // Combine loading states
  const loading = refreshLoading || accountStateLoading;

  return {
    userData,
    subscriptionStatus,
    loading,
    refreshUserData,
    updateProfileImage
  };
};
